// audit-format.ts — mise en forme PARTAGÉE des lignes d'audit de l'IdP.
//
// Deux écrans lisent ces mêmes actions : la page Journal (toutes identités confondues) et la fiche d'un
// compte dans l'écran Utilisateurs. Une action doit s'y colorer et s'y classer de la MÊME façon —
// sinon le même échec de connexion paraît anodin d'un côté et grave de l'autre (règle de 2, §24.3).

/** Couleur d'une action : succès (vert), échec/verrou (rouge), sinon neutre. */
export const auditColor = (a: string) =>
  (a.includes('success') || a.endsWith('.complete') || a.startsWith('account.') ? 'var(--ok-fg)'
    : a.includes('fail') || a.includes('locked') ? 'var(--da-fg)'
      : 'var(--ink600)');

/** Une action qui doit SE VOIR à la ligne : une série d'échecs se repère d'un coup d'œil, pas en lisant. */
export const auditFailed = (a: string) => a.includes('fail') || a.includes('locked') || a.includes('denied');

/**
 * Familles d'audit — dérivées des ACTIONS RÉELLES émises par l'IdP, jamais d'une nomenclature inventée :
 * un filtre qui ne correspond à rien renvoie une liste vide et fait croire à une absence d'événement.
 */
export const AUDIT_FAMS: { k: string; label: string; match: (a: string) => boolean }[] = [
  { k: 'tout', label: 'tout', match: () => true },
  { k: 'connexions', label: 'connexions', match: (a) => a.startsWith('login') && !a.includes('fail') },
  { k: 'echecs', label: 'échecs', match: auditFailed },
  { k: '2fa', label: '2FA', match: (a) => a.includes('2fa') || a.includes('totp') || a.includes('recovery') },
  { k: 'grants', label: 'accès accordés', match: (a) => a.includes('grant') || a.includes('scope') || a.includes('role') },
  { k: 'secours', label: 'connexion de secours', match: (a) => a.includes('break') || a.includes('bootstrap') || a.includes('local') },
];
